import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom' 
import Button from './Buttons/Button'
import DividerLine from "./DividerLine"

const Footer = () => {
    const { t } = useTranslation()

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    return(
        <div>
            <DividerLine mt={'10'} mb={'10'}/>

            <div className='grid lg:grid-cols-2 xl:grid-cols-2 px-10'>
                <div className="pt-0">
                    <p className="text-gray-500 font-medium">{ t('footer_connect') }</p>
                    <div className="mt-6 space-y-5 flex-col justify-start">
                        {/* <a href="" target="_blank" rel="noreferrer">
                            <p className="font-semibold my-4 text-xl lg:text-3xl xl:text-4xl">@binary.brains</p>
                        </a> */}
                        <a href="https://www.instagram.com/binarybrains.dev/" target="_blank" rel="noreferrer">
                            <p className="font-semibold my-4 text-xl lg:text-3xl xl:text-4xl grow">@binarybrains.dev</p>
                        </a>
                        <a href="mailto:binarybrains.dev@gmail.com" target="_blank" rel="noreferrer">
                            <p className="font-semibold my-4 text-xl lg:text-3xl xl:text-4xl grow">binarybrains.dev@gmail.com</p>
                        </a>
                        <a href="https://wa.me/5491131918140" target="_blank" rel="noreferrer">
                            <p className="font-semibold my-4 text-xl lg:text-3xl xl:text-4xl grow">+54 9 1131918140</p>
                        </a>
                        
                        <Button call={ t('footer_button') } link={'/contact'}/>
                    </div>
                </div>
            </div>

            <DividerLine mt={'10'} mb={'12'}/>

            <div className="flex-col md:flex-row lg:flex-row xl:flex-row px-10 pt-10 pb-2 md:px-14 lg:px-14 xl:px-14 -mt-4 mb-6 flex justify-between ">
                <p>{ t('footer_disclaimer') }</p>
                <div className="flex flex-col sm:flex-row md:flex-row lg:flex-row xl:flex-row sm:space-x-10 md:space-x-10 lg:space-x-10 xl:space-x-10 mt-4 md:mt-0 lg:mt-0 xl:mt-0">
                    <Link onClick={() => scrollToTop()} to='/terms-of-service'><p className='w-max'>{ t('footer_terms') }</p></Link>
                    <Link onClick={() => scrollToTop()} to='/privacy-policy'><p className='w-max'>{ t('footer_privacy') }</p></Link>
                </div>
            </div>
        </div>
    )    
}

export default Footer